export const POLLING_INTERVAL = 10000;

const statusesToVerify = [
  "sitradi_block_status",
  "payment_status_deadline",
  "sitradi_immobilization_status",
];

export const extractVolanteStatus = (volante) => {
  const statuses = statusesToVerify.map((key) => ({ ...volante[key], key }));
  const problems = statuses.filter((status) => status.category === "problem");
  const warnings = statuses.filter((status) => status.category === "warning");
  return { problems, warnings };
};

export const paymentConvertResponse = (res) => {
  const quotation_ids = res.quotations.map((detail) => detail.quotation_id);
  const details = res.quotations.map((detail) => {
    const withdrawalDate = detail.withdrawal_date;
    const paymentStatus = detail.payment_status;
    const typePaymentCreditContaReca = detail.payment_type?.option;
    const status = extractVolanteStatus(detail.volante);
    const bankTypeLabel = detail?.bank?.label;
    const payment_type = detail.payment_type;

    const disabledCheckbox =
      status.problems.length > 0 ||
      detail.volante.payment_status.option === "rejected";

    const disabledCheckboxQuoted =
      status.problems.length > 0 ||
      detail.volante.payment_status.option === "rejected";

    const limitQuotationComment = detail.limit_quotation_comment
      ? detail.limit_quotation_comment
      : 124;

    return {
      status,
      disabledCheckbox: disabledCheckboxQuoted,
      disabledPending: !disabledCheckbox,

      id: detail.quotation_id,
      quotationNum: detail.factura_num,
      electronicFacNum: detail.electronic_factura_num,
      bankPaymentCode: detail?.bank_payment_code || "",
      upfrontBankPaymentCode: detail?.bank?.bank_payment_code || "",
      typePaymentCreditContaReca,
      payment_type,
      bankTypeLabel,
      payerRucOption: detail.credit_payment_detail?.payer_ruc.option,
      bankNameQuotation: detail.bank?.name || "",
      ruc: detail.billable_ruc,
      days: detail.volante["days_stored"],
      amount: detail.sales_price_total,
      importer: detail.volante["consignee_name"],
      paymentStatus,
      sitradiBlockStatus: detail.volante["sitradi_block_status"],
      sitradiImmobilizationStatus:
        detail.volante["sitradi_immobilization_status"],
      volanteId: detail.volante["volante_num"],
      numParcels: detail.volante["parcels_num"],
      weight: detail.volante["parcels_weight"],
      withdrawalDate,
      paymentCode: detail.bank_payment_code || "",
      creditLineAuthorizationStatus:
        detail.volante["credit_line_usage_authorization_status"],
      quotationDoc: detail.quotation_doc,
      consigneeRuc: detail.volante["consignee_ruc"],
      quotationComment: detail.quotation_comment,
      limitQuotationComment: limitQuotationComment,
      quotationRejectedComment: detail.quotation_rejected_comment,
      vouchers: detail.vouchers,
      factura_num: detail.factura_num,
    };
  });

  const disabledAll = details.every((item) => item.disabledCheckbox);
  const disabledAllPending = details.every((item) => item.disabledPending);

  return {
    details,
    num_pages: res.num_pages,
    page_size: res.page_size,
    count: res.count,
    disabledAll,
    disabledAllPending,
    quotation_ids,
  };
};

const extractVolanteStatusQuoted = (volante) => {
  const statusRestriction = volante.restrictions.map(
    (restriction) => restriction.info
  );
  const problems = statusRestriction.filter(
    (status) => status.category === "problem"
  );
  const warnings = statusRestriction.filter(
    (status) => status.category === "warning"
  );

  return { problems, warnings };
};

export const paymentQuotedConvertResponse = (res) => {
  const quotation_ids = res.quotations.map((detail) => detail.quotation_id);
  const details = res.quotations.map((detail) => {
    const withdrawalDate = detail.withdrawal_date;
    const paymentStatus = detail.payment_status;
    const status = extractVolanteStatusQuoted(detail);
    const quotation_process_status = detail.quotation_process_status.option;

    const disabledCheckboxQuoted =
      status.problems.length > 0 ||
      detail.volante.payment_status.option === "rejected" ||
      quotation_process_status !== "processed";

    const limitQuotationComment = detail.limit_quotation_comment
      ? detail.limit_quotation_comment
      : 124;
    const editCommentVolante = detail.actions.includes("edit");
    const deleteVolante = detail.actions.includes("delete");
    return {
      status,
      disabledCheckbox: disabledCheckboxQuoted,
      id: detail.quotation_id,
      quotationNum: detail.factura_num,
      ruc: detail.billable_ruc,
      amount: detail.sales_price_total,
      importer: detail.volante["consignee_name"],
      paymentStatus,
      volanteId: detail.volante["volante_num"],
      withdrawalDate,
      consigneeRuc: detail.volante["consignee_ruc"],
      quotationComment: detail.quotation_comment,
      limitQuotationComment: limitQuotationComment,
      quotationRejectedComment: detail.quotation_rejected_comment,
      volanteStatus: detail.quotation_process_status,
      quotation_process_status,
      quotation_translate_error_message:
        detail.quotation_translated_error_message,
      editCommentVolante,
      deleteVolante,
    };
  });

  const disabledAll = details.every((item) => item.disabledCheckbox);

  return {
    details,
    num_pages: res.num_pages,
    page_size: res.page_size,
    count: res.count,
    disabledAll,
    quotation_ids,
  };
};
